import * as React from 'react'
import { StaticImage } from "gatsby-plugin-image"

const Banner = () => {
    return (
        <>
            <div>
                <StaticImage  src="../images/banner-top.jpg" alt="banner1" />
            </div>
            <div className='sticky top-0 z-5'>
                <StaticImage  src="../images/banner-bottom.jpg" alt="banner2" />
            </div>
        </>
    )
}

export default Banner
